






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { LessonListDTO } from '../../../../src_server/entity/dto/LessonListDTO';
@Component({ components: {} })
export default class TeacherMovieCard extends Vue {
  @Prop()
  dto!: LessonListDTO;

  get youtubeEmbedUrl() {
    const url = this.dto.teacher?.appeal_movie_url;
    if (!url) {
      return '';
    }
    const uriEnd = url.split('/').reverse()[0];
    return 'https://www.youtube.com/embed/' + uriEnd;
  }
}
